module.exports = __webpack_public_path__ + "static/media/close.21e26798.svg";